<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="$parent.close"></button></span>
    <div slot="content">
      <el-form ref="form" :model="form" size="mini" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="제목">
              <el-input v-model="form.docNm" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="조회수">
              <el-input v-model="form.readCnt" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="확인자수">
              <el-input v-model="form.confirmCnt" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="이름">
              <el-input v-model="form.creatorNm" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="작성일자">
              <el-input v-model="form.createDt" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="13">
                <el-form-item label="공지기간">
                  <el-input v-model="form.startDtText" readonly></el-input>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2" style="text-align: center;">-</el-col>
              <el-col :span="9" style="margin-left: 0px;">
                <el-form-item label-width="10px">
                  <el-input v-model="form.endDtText" readonly></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item label="중요도">
              <el-input v-model="form.importanceText" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="ck-editor">
              <ckeditor id="readEdit"
                  :editor="editor"
                  v-model="form.html"
                  :config="editorConfig"
                  @ready="onEditorReady"
                  @focus="onEditorFocus"
                  @blur="onEditorBlur"
                  @input="onEditorInput"
                  @destroy="onEditorDestroy"
              />
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item
                label="첨부파일"
                label-width="10"
                >
              <el-upload
                  disabled
                  :file-list="fileList"
                  class="upload-demo"
                  action=""
                  :on-preview="fileDownload"
                  :on-change="handleChange"
                />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </layout>
</template>
<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import _ from "lodash";
import ButtonCellRenderer from '@/components/agGrid/button-cell-renderer'
import AgGridScanAttach from "@/components/agGrid/AgGridScanAttach";
import Layout from '@/components/Slot/ModalSlot.vue';

export default {
  name:'boardMngRead',
  props:['custParam','title'],
  components: {Layout},
  data(){
    return {
      // title:'',
      editor: ClassicEditor,
      editorData: '<p> 에디터에 데이터를 입력하세요. </p>',
      editorConfig: {
        language: 'en',
      },
      gridOptions: {
        // onColumnResized: true,
        // enableFilter: true,
        // enableSorting: true,
        // suppressRowTransform: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        //editable: true
      },
      gridApi : null ,    //gridAip
      columnApi : null ,  //columApi
      columnComment: [] ,    //comulum Defs
      boardId:'',
      commentData:[],
      // boardInfo:{},
      form:{
        approvalYn : "",
        confirmCnt : "",
        content : "",
        createDt : "",
        creatorGroupUid : "",
        creatorId : "",
        creatorNm : "",
        deleteYn : "",
        docId : "",
        docIdx : "",
        docLvl : "",
        docNm : "",
        docNo : "",
        docPath : "",
        endDt : "",
        endDtText : "",
        html : "",
        importance : "",
        importanceText : "",
        ip : "",
        noticeYn : "",
        parentId : "",
        publicYn : "",
        pwd : "",
        readCnt : "",
        sortPath : "",
        srcId1 : "",
        srcId2 : "",
        srcId3 : "",
        srcId4 : "",
        startDt : "",
        startDtText : "",
        updateDt : "",
        updatorId : "",
      },
      cForm :{
        commentId : "",
        commentNm : "",
        html : "",
        cotent : "",
      },
      defForm:{
        approvalYn : "",
        confirmCnt : "",
        content : "",
        createDt : "",
        creatorGroupUid : "",
        creatorId : "",
        creatorNm : "",
        deleteYn : "",
        docId : "",
        docIdx : "",
        docLvl : "",
        docNm : "",
        docNo : "",
        docPath : "",
        endDt : "",
        endDtText : "",
        html : "",
        importance : "",
        importanceText : "",
        ip : "",
        noticeYn : "Y",
        parentId : "",
        publicYn : "",
        pwd : "",
        readCnt : "",
        sortPath : "",
        srcId1 : "",
        srcId2 : "",
        srcId3 : "",
        srcId4 : "",
        startDt : "",
        startDtText : "",
        asAgentId : "",
        updateDt : "",
        updatorId : "",
      },
      defCForm :{
        commentId : "",
        commentNm : "",
        html : "",
        cotent : "",
      },
      admin:{
        id:'',
        boardCd:'',
        boardSubCd:'',
        bSubject:'답변',
        bContent:'',
        attribute1:'',
        attribute2:'',
        attribute3:'',
        bReply:'N'
      },
      frameworkComponents: {
        AgGridScanAttach: AgGridScanAttach,
      },
      adminR:[],
      resp:'',
      fileList:[],
      imageList:[],
      editorOptions : {
        theme:'bubble'
      }
    }
  },
  created(){
    //this.boardInfo = this.$route.params.boardInfo;
    //this.title = this.this.$route.params.title;
  },
  beforeMount() {
    this.getParameter();
  },
  mounted(){

    this.setInfo();
    this.getFileList();
    this.getImageList();
    this.getCommentList();

    this.createColumnComment();

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      buttonCellRenderer: ButtonCellRenderer,
    };


  },
  methods:{
    getParameter(){
      const {parameter} = this.$menu.getGrants();
      if(parameter) {
        this.parameter = parameter.parameter.split("&");
        if(this.parameter) {
          this.parameter.map( (x, i) => {
            if(i == 0) {
              this.srcId1 = x.substring(x.indexOf("=") + 1); // 콜센터,센터 구분
            }
            if(i == 1) {
              this.srcId2 = x.substring(x.indexOf("=") + 1); // 공지,일반 구분
            }
            if(i == 2) {
              this.srcId3 = x.substring(x.indexOf("=") + 1); // 게시판 종류 구분
            }
          })
        }
        // if(this.parameter.length > 0 && this.parameter.length <= 3){ 
        //   this.srcId1 = this.parameter[0].substring(this.parameter[0].indexOf('=')+1); // 콜센터,센터 구분
        //   this.srcId2 = this.parameter[1].substring(this.parameter[1].indexOf('=')+1); // 공지,일반 구분
        //   this.srcId3 = this.parameter[2].substring(this.parameter[2].indexOf('=')+1); // 게시판 종류 구분
        // }
      }
    },
    goComment(){

      this.cForm.content =  this.cForm.html.replace(/<[^>]*>?/g, '');

      this.$http
          .put('/api/boardMng/comment/save',{
            companyId: this.$store.state.loginInfo.compCd,
            srcId1: 'DOC',
            srcId2: this.form.docId,
            srcId3: '',
            srcId4: '',
            mark: 0,
            commentNm: '',
            content: this.cForm.content,
            html: this.cForm.html,
            creatorNm : this.$store.state.loginInfo.userName,
            pwd: '',
            creatorId: this.$store.state.loginInfo.id,
            processTime: "",
            commentId:0
          })
          .then(response => {
            // this.$swal({ type: 'success', text: '저장되었습니다.' });
            this.cForm = _.clone(this.defCForm);
            this.getCommentList();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
    },
    //컬럼정의 함수
    createColumnComment() {
      const vm = this;

      this.columnComment = [
        {
          headerName: '작성자',
          width : 250 ,
          field: 'creatorNm',
          cellStyle:{textAlign: 'center'}
        },
        {
          headerName: '작성일'
          , width : 400
          , field: 'createDt'
          , cellStyle:{textAlign: 'center'},
          valueFormatter: (params) => {
            return vm.getDateFormat(`${params.value}`)
          }
        },
        {
          headerName: '내용',
          width : 1200 ,
          field: 'content',
          cellStyle:{textAlign: 'left'}
        },
        {
          headerName: '',
          width : 150 ,
          field : 'del',
          editable: false,
          cellRenderer: 'buttonCellRenderer',
          cellRendererParams: {
            name: '삭제'
          }
        },
      ]
    },
    indexMethod(index) {
      return ++index;
    },
    dateFormatter(row, column) {
      return this.$moment(row.date).format('yyyy-MM-DD HH:mm:ss')
    },
    deleted(index, row) {


      this.$http
          .put('/api/boardMng/comment/delete',{
            companyId: this.$store.state.loginInfo.compCd,
            commentId: row.commentId,
            updatorId: this.$store.state.loginInfo.id,
            processTime: ""
          })
          .then(response => {
            this.$swal({ type: 'success', text: '삭제되었습니다.' });
            this.getCommentList();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
    },
    handleChange(uploadFile, uploadFiles) {
      this.fileList.value = this.fileList.value.slice(-3)
    },
    getCommentList(){
      this.$store.commit('loading')
      this.$http.post(`/api/boardMng/comment/list`,{
        companyId: this.$store.state.loginInfo.compCd,
        srcId1: "DOC",
        srcId2: this.form.docId,
        srcId3: "",
        srcId4: "",
        sortType : true,
        page : 1,
        totalPage : 9999,
        totalCount : 9999,
        curPage : 0,
        processTime : ""
      })
          .then(response => {
            this.commentData = response.data;
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    getFileList(){
      this.$store.commit('loading')
      this.$http.post(`/api/boardMng/file/list`,{
        companyId: this.$store.state.loginInfo.compCd,
        srcId1: "DOC",
        srcId2: this.form.docId,
        srcId3: "",
        srcId4: "",
        processTime : ""
      })
        .then(response => {
            this.fileList = response.data;
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    getImageList(){
      this.$store.commit('loading')
      this.$http.post(`/api/boardMng/image/list`,{
        companyId: this.$store.state.loginInfo.compCd,
        srcId1: "DOC",
        srcId2: this.form.docId,
        srcId3: "",
        srcId4: "",
        processTime : ""
      })
          .then(response => {
            this.imageList = response.data;
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    goList(){
      this.cancel();
      this.viewType = 'list';
      this.$emit('viewType');
    },
    goModify(){
      this.cancel();
      this.viewType = 'modify';
      this.$emit('viewType');
    },
    goRefresh(){
      this.cancel();
      this.viewType = 'list';
      this.$emit('refresh');
    },
    cancel(){
      // CatInfo 초기화
      this.form = _.clone(this.defForm);
    },
    goDeleted(){
      this.$http
          .put('/api/boardMng/delete',{
            companyId: this.$store.state.loginInfo.compCd,
            docId:this.form.docId,
            updatorId: this.$store.state.loginInfo.id,
            processTime: ""
          })
          .then(response => {
            this.$swal({ type: 'success', text: '저장되었습니다.' });
            this.goRefresh();
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
    },
    typeSwitch(type){
      switch (type){
        case 'Normal':
          return type ='일반공지';
        case 'Importance':
          return type ='기술공지';
      }
    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    fileDownload(file){
      this.$store.commit('loading')
      
      this.$http.get(`/api/v1/download/board/${file.storeName}/${file.fileId}`,{ responseType: 'blob' })
        .then((response) => {
            //back-end local header config path 실제 존재 경로에서 가져온 데이터를 그대로 세팅.
            let link = document.createElement('a');
            link.href = response.config.url;

            link.setAttribute('download', file.name);

            document.body.appendChild(link);
            link.click();
        
        }).catch(err => {
          this.$message.error(`${err.response.status == 404 ? '파일이 존재하지 않습니다.' : err.response.data.message}`);
        }).finally(()=> {
          this.$store.commit('finish');
        });
      // this.$store.commit('loading')
      // console.log("file download file ", file)
      // this.$http.get(`/api/v1/download/board/${file.storedName}`,{ responseType: 'blob' })
      //     .then((response) => {
      //       const downloadedfile = new Blob([response.data], { type: 'blob' });
      //       let url;

      //       const contentDisposition = response.headers['content-disposition'];
      //       let fileName = 'unknown';
      //       if (contentDisposition) {
      //         const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
      //         if (fileNameMatch.length === 2)
      //           fileName = fileNameMatch[1];
      //       }

      //       if (window.navigator.msSaveOrOpenBlob) {
      //         window.navigator.msSaveOrOpenBlob(downloadedfile, fileName);
      //       } else {
      //         url = window.URL.createObjectURL(downloadedfile);

      //         const link = document.createElement('a');
      //         link.href = url;
      //         link.setAttribute('download', file.originalName);
      //         document.body.appendChild(link);
      //         link.click();
      //       }

      //     }).catch(response => {
      //   console.log("catch response" , response)
      // }).finally(()=> {
      //   this.$store.commit('finish');
      // });

    },
    addReply(){
      // if(!this.admin.bContent){
      //     this.$swal({type: 'warning', text: '내용을 입력해 주세요.'});
      //     return false;
      // }
      // this.form.bReply='Y'
      // this.$http.put(`/api/board/updateBoardDetail/${this.form.id}`, this.form)
      //
      // this.$http.post(`/api/board/addBoard`, this.admin)
      // .then(response=>{
      //     console.log("댓글 저장")
      //     this.resp = response.data;
      //     this.$swal({
      //         type: 'success',
      //         text: '댓글 등록완료.'
      //     }).then(() => {
      //         this.$router.push({
      //             name: 'ListSuggest',
      //         })
      //     })
      // })
    },
    onEditorReady(eventInfo) {
      eventInfo.editing.view.change((writer)=> {
        writer.setStyle("height", "400px", eventInfo.editing.view.document.getRoot())
      });
      eventInfo.enableReadOnlyMode("#readEdit",true)
      const toolbarElement = eventInfo.ui.view.toolbar.element; //toolbar element 객체 담기
      toolbarElement.style.display = "none"; //해당 객체 display none 처리
    },
    onEditorFocus(eventInfo, data ) {
      // console.log('onEditorFocus', eventInfo, data);
    },
    onEditorBlur(eventInfo, data ) {
      // console.log('onEditorBlur', eventInfo, data);
    },
    onEditorInput(eventInfo, batch) {
      // console.log('onEditorInput', eventInfo, batch);
      //Corresponds to the change:data editor event. See the v-model directive to learn more.
    },
    onEditorDestroy(eventInfo) {
      // console.log('onEditorDestroy', eventInfo);
    },
    setInfo() {
      Object.assign(this.form, this.custParam);
      this.form.importanceText = this.typeSwitch(this.form.importance);
      this.form.startDtText = this.getDateFormat(this.form.startDt);
      this.form.endDtText = this.getDateFormat(this.form.endDt);
    },
  },
  watch: {
    custParam() {
      this.setInfo();
    }
  }
}
</script>
<style lang="scss" scoped>
.el-upload{
  display: none !important;
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px;
  border-radius: 5px;
}
.el-row {
  border-bottom: 1px solid #d7d7d7;
  margin-top: 7px;
}
</style>